import { u as IPSTACK_COOKIE_NAME, v as IPSTACK_URL } from './built-constants-439d5572.js';
import { C as Cookies } from './built-js.cookie-7baadf9c.js';

// @ts-check

/**
 * Throws an error if the original response is not OK
 * @param {Response} response - A fetch response object
 * @returns {Response} - The same response
 * @throws {Error} - Containing details about the problem with the response
 */
const rejectIfNotOk = response => {
  // Response should be `ok=true` and `status=200`
  const {
    status,
    statusText
  } = response;

  if (!response.ok) {
    throw new Error("Fetch returned status: " + status + " and statusText: " + statusText + ".");
  }

  return response;
};

// @ts-check
/**
 * @typedef {Object} LocationInfo
 * @property {string} zip_code - A user's Zip Code
 * @property {string} city - A user's city name
 * @property {string} region_code - A user's state abbr, usually
 * @property {string} country_code - A user's country abbr
 * @property {number} latitude - A user's latitude
 * @property {number} longitude - A user's longitude
 * @property {string} region_name
 */

/**
 * A custom type with cherry-picked properties from the `LocationInfo` type
 * @typedef {Pick<LocationInfo, 'country_code' | 'region_code'>} BasicLocationInfo
 */

/**
 * Get a user's location via IP, using ipstack
 * @see https://apilayer.com
 * @returns {Promise<LocationInfo>} Current location or null if location
 * cannot be retrieved
 */

const getCurrentLocation = async () => {
  const customMessage = 'Error getting user location by IP';

  try {
    const savedIPStackResponse = JSON.parse(Cookies.get(IPSTACK_COOKIE_NAME) || 'null');
    if (savedIPStackResponse == null ? void 0 : savedIPStackResponse.locale) return savedIPStackResponse.locale;
    const response = await fetch(IPSTACK_URL).then(rejectIfNotOk);
    const json = await response.json();
    return json;
  } catch (error) {
    error.message = error.message + ": " + customMessage;
    throw error;
  }
};
/**
 * @todo If these values are needed outside of this module in the future,
 * they can be abstracted out into a shared constants file.
 * @todo Also consider offering these as Admin settings in the future if it makes sense.
 */

const COUNTRY_ALLOW_LIST = ['US'];
const STATE_ALLOW_LIST = ['CA'];
/**
 * Determines whether a location is in approved range for store pickup
 * @param {BasicLocationInfo} location
 */

const isLocationPickupApproved = location => COUNTRY_ALLOW_LIST.some(country => country === (location == null ? void 0 : location.country_code)) && STATE_ALLOW_LIST.some(state => state === (location == null ? void 0 : location.region_code));

export { getCurrentLocation as g, isLocationPickupApproved as i };
